export const AGENT_NAME_MISSING = "AGENT_NAME_MISSING";
export const AGENT_ID_MISSING = "AGENT_ID_MISSING";
export const AGENT_ID_NOT_MATCHING = "AGENT_ID_NOT_MATCHING";
export const AGENT_NAME_NOT_MATCHING = "AGENT_NAME_NOT_MATCHING";

export const QUEUE_NAME_MISSING = "QUEUE_NAME_MISSING";
export const QUEUE_ID_MISSING = "QUEUE_ID_MISSING";
export const QUEUE_ID_NOT_MATCHING = "QUEUE_ID_NOT_MATCHING";
export const QUEUE_NAME_NOT_MATCHING = "QUEUE_NAME_NOT_MATCHING";

export const ASSIGNMENT_DUPLICATE = "ASSIGNMENT_DUPLICATE";

export const MEDIA_TYPE_MISSING = "MEDIA_TYPE_MISSING";
export const MEDIA_TYPE_NOT_MATCHING = "MEDIA_TYPE_NOT_MATCHING";

export const VALIDATION_MESSAGES = Object.freeze({
  [AGENT_NAME_MISSING]: "Agent name is missing",
  [AGENT_ID_MISSING]: "Agent ID is missing",
  [AGENT_NAME_NOT_MATCHING]:
    "Agent name '{agentName}' does not match ID '{agentId}'",
  [AGENT_ID_NOT_MATCHING]:
    "Agent ID '{agentId}' does not match name '{agentName}'",

  [QUEUE_NAME_MISSING]: "Queue name is missing",
  [QUEUE_ID_MISSING]: "Queue ID is missing",
  [QUEUE_NAME_NOT_MATCHING]:
    "Queue name '{queueName}' does not match ID '{queueId}'",
  [QUEUE_ID_NOT_MATCHING]:
    "Queue ID '{queueId}' does not match name '{queueName}'",

  [ASSIGNMENT_DUPLICATE]:
    "Agent '{agentName}' is assigned to queue '{queueName}' more than once",

  [MEDIA_TYPE_MISSING]: "Media type is missing",
  [MEDIA_TYPE_NOT_MATCHING]:
    "Media type '{mediaType}' does not match that of queue '{queue}'",

  format: (field, params) => {
    let formattedMessage = VALIDATION_MESSAGES[field];
    for (const replacement of Object.entries(params)) {
      const [marker, value] = replacement;
      formattedMessage = formattedMessage.replaceAll(`{${marker}}`, value);
    }
    return formattedMessage;
  },
});
